import React from "react";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { useHistory, useParams } from 'react-router-dom';

const PaginationHelper = () => {
  const history = useHistory();
  const { limit, skip } = useParams();
  const _limit = parseInt(limit);
  const _skip = parseInt(skip);
  const { t } = useTranslation();

  const Pagination_helper = (total, rout, filtter) => {
    const handlePageClick = async (envent) => {
      let currentPage = envent.selected + 1;
      history.push(rout + currentPage, filtter);
    };
    return (
      <ReactPaginate
        previousLabel={t("previous_pagination_title")}
        onPageChange={handlePageClick}
        breakLabel="..."
        pageRangeDisplayed={2}
        pageCount={Math.ceil(total / _limit)}
        marginPagesDisplayed={2}
        renderOnZeroPageCount={null}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
        forcePage={_skip - 1}
        nextLabel={t("next_pagination_title")}
      />
    );
  };
  return {
    _limit,
    _skip,
    Pagination_helper,
  };
};
export default PaginationHelper;
